export const scrollWithOffset = (el: any, offset: number) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -offset;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
};